export const jsmContextualRovoKillswitchKey = 'grw-524_jsm_jpd_rovo_sidekick_killswitch';
